import React from 'react';
import { Clickable, LoadingBalls, Overlay } from '@moda/om';
import { isApplePaySupported } from '../../lib/apple/isApplePaySupported';
import { SetupApplePaySession } from './SetupApplePaySession';
import './ApplePayButton.scss';

export const APPLE_PAY_BUTTON_ID = 'apple-pay-button';

type Props = {
  size?: 'small' | 'large';
  onClick?: () => void;
  onError?: (error: unknown) => void;
  session?: ApplePaySession | null;
};

export const ApplePayButton: React.FC<Props> = ({ size = 'large', onClick, onError, session }) => {
  if (!isApplePaySupported()) return null;

  return (
    <Clickable
      className={`ApplePayButton ApplePayButton--${size}`}
      onClick={session ? undefined : onClick}
    >
      {session && (
        <>
          <SetupApplePaySession session={session} onError={onError} />
          <Overlay>
            <LoadingBalls />
          </Overlay>
        </>
      )}

      <div id={APPLE_PAY_BUTTON_ID} />
    </Clickable>
  );
};
